import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsGlobalPermissionsRoute } from '@atlassian/jira-router-routes-admin-pages-global-permissions-routes/src/globalSettingsGlobalPermissionsRoute.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalPermissionsEntryPoint } from '@atlassian/jira-global-permissions/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsGlobalPermissionsRouteEntry: Route = createEntry(
	globalSettingsGlobalPermissionsRoute,

	() => ({
		entryPoint() {
			return fg('olympus-global-permissions-fe-modernisation')
				? createPageEntryPoint({
						main: globalPermissionsEntryPoint,
						topNavigationMenuId: MENU_ID.PROJECTS,
					})
				: undefined;
		},

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_SYSTEM_SETTINGS,
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-global-permissions-entries/src/globalSettingsGlobalPermissionsRouteEntry.tsx',
				whichExportToUse: 'globalSettingsGlobalPermissionsRouteEntry',
			},

			enabled: true,
		},
	}),
);
